import Sentry from "@similarweb/sentry-logger";

import { fetchService } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignsCampaignUtils";

import type { QueryParams } from "../../types";

export const fetchData = async <T>(endpoint: string, params: QueryParams): Promise<T> => {
    try {
        const response = await fetchService.get(endpoint, {
            ...params,
        });
        return response as T;
    } catch (error) {
        Sentry.error(`Failed to fetch data from ${endpoint}`, error);
    }
};
